import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../../services/api';
import toast from 'react-hot-toast';

const VerifyEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('pending'); // 'pending' | 'success' | 'error'
  const [message, setMessage] = useState('');
  const hasVerifiedRef = useRef(false);

  useEffect(() => {
    // Prevent double execution in React StrictMode (development)
    if (hasVerifiedRef.current) return;

    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');

    const verify = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Verification token is missing or invalid.');
        return;
      }

      try {
        hasVerifiedRef.current = true;
        const response = await authAPI.verifyEmail(token);
        const msg = response.data?.message || 'Email verified successfully.';
        setStatus('success');
        setMessage(msg);
        toast.success(msg);
      } catch (error) {
        const msg =
          error.response?.data?.message ||
          'Email verification failed. The link may have expired or is invalid.';
        setStatus('error');
        setMessage(msg);
        toast.error(msg);
      }
    };

    verify();
  }, [location]);

  const handleGoToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-2xl shadow p-8 text-center">
        {status === 'pending' && (
          <>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Verifying email...</h2>
            <p className="text-sm text-gray-600">
              Please wait while we verify your email address.
            </p>
          </>
        )}

        {status !== 'pending' && (
          <>
            <h2
              className={`text-xl font-semibold mb-2 ${
                status === 'success' ? 'text-green-600' : 'text-red-600'
              }`}
            >
              {status === 'success' ? 'Email verified' : 'Verification failed'}
            </h2>
            <p className="text-sm text-gray-700 mb-6">{message}</p>

            <button
              onClick={handleGoToLogin}
              className="inline-flex items-center px-4 py-2 rounded-lg bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700"
            >
              Go to login
            </button>

            <div className="mt-4 text-xs text-gray-500">
              Or{' '}
              <Link to="/" className="text-indigo-600 hover:text-indigo-500">
                go to home page
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;


